import messages from './cmsArticle.json' with { type: 'json' };

export const cmsArticleEn: Readonly<typeof messages> = messages;
